export default __webpack_public_path__ + "static/media/ipad-system-volume-01.15294f07.svg";